export const PACKAGES_PATH = 'packages';
export const EXTENSIONS_PATH = 'extensions';

// Phase 1 ships under the experimental version; move to a numbered slot before GA.
export const API_VERSION = 'exp';

// Mirror RestApiErrorResponseCode.java in the monolith.
export const ERROR_CODE_PACKAGE_ALREADY_EXISTS = '409911';
export const ERROR_CODE_PACKAGE_MANIFEST_MISMATCH = '409131';
